import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
// Reemplaza estos imports con las rutas reales de tus servicios y modelos
import { UsuariosService } from 'src/app/core/services/usuarios.service'; 
import { UsuarioAccesoService } from 'src/app/core/services/usuario_acceso.service';
import { NotificationService } from 'src/app/core/services/notification.service';

interface UsuarioGrupo {
  id: string;
  nombre: string;
  correo: string;
  rol: string;
}

interface Item {
    id_usuario_grupo?: string;
    id_usuario: string,
    grupo: string;
    nombre: string;
    correo: string;
    permitido: boolean;
}

@Component({
  selector: 'app-usuarios-grupo-modal',
  templateUrl: './usuarios-grupo-modal.component.html',
  styleUrls: []
})
export class UsuariosGrupoModalComponent implements OnInit {
  // Recibe el ID del grupo desde el componente padre
  @Input() grupoId!: any;
  @Input() itemId!: any;
  @Input() model!: any;
  @Input() modeloAcceso!: any;

  // Callback opcional
  @Input() onAgregar?: (data?: any) => void | Promise<void>;
  
  // Texto opcional del botón
  @Input() agregarLabel: string = 'Agregar';

  @Input() accionLabel:string = '';

  currentItems: Item[] = [];
  spinner: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private usuarioAccesoService: UsuarioAccesoService,
    private usuarioService: UsuariosService, // Tu servicio para consultar los usuarios
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    if (this.grupoId) {
      this.cargarUsuariosPorGrupo();
    }
  }

  async clickAgregar() {
    // Si el padre mandó callback, ejecuta esa acción
    if (this.onAgregar) {
      await this.onAgregar({
        grupoId: this.grupoId,
        usuarios: this.currentItems
      });

      return;
    }

    // Si no mandó callback, ejecuta la acción normal
    this.agregarUsuariosGrupo();
  }

  async cargarUsuariosPorGrupo() {
    this.spinner = true;
    try {
      let params = new HttpParams().set('id_grupo', this.grupoId);
      const result = await lastValueFrom(this.usuarioService.userGroups(params));
      this.currentItems = result.body.map((x: any, index: number) => {
          return { id_usuario_grupo: x.id, id_usuario: x.usuario.id, grupo: x.grupo.nombre, nombre: (x.usuario.firstName + ' ' + x.usuario.lastName), correo: x.usuario.email, permitido: true ,
              default_cert: x?.certificado?.id , default_scratchcard: x?.certificado?.scratchcard
           }
      });
    } catch (error) {
      console.error('Error al cargar usuarios del grupo:', error);
    } finally {
      this.spinner = false;
    }
  }

  // Esta función se ejecuta automáticamente al cambiar el checkbox de cualquier fila
  async actualizarAccesoUsuario(usuario: any) {
    try {
      
    } catch (error) {
      console.error('Error al actualizar el acceso:', error);
      // Si la API falla, revertimos el checkbox al estado anterior en la interfaz de usuario
      usuario.permitido = !usuario.permitido; 
      console.error('error', 'No se pudo actualizar el estado');
    }
  }

  async agregarUsuariosGrupo() {
    const usuariosPermitidos = this.currentItems
      .filter(usuario => usuario.permitido === true)
      .map(usuario => {
        return {
          id_item: this.itemId,               // El ID del grupo/plantilla origen
          id_usuario: usuario.id_usuario, // El ID del usuario específico
          modelo: this.modeloAcceso
        };
      });

    
    if (usuariosPermitidos.length) {
      const response = await lastValueFrom(this.usuarioAccesoService.post(usuariosPermitidos));
      this.notificationService.showSuccess((response as any).message,'Datos agregados con éxito');

    }
    this.activeModal.close();
  }
}